import { render, staticRenderFns } from "./CreateWholesaleOrder.vue?vue&type=template&id=0676fed8"
import script from "./CreateWholesaleOrder.vue?vue&type=script&lang=js"
export * from "./CreateWholesaleOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports